import { render, staticRenderFns } from "./teacherPaper.vue?vue&type=template&id=f5fe46f8&scoped=true&"
import script from "./teacherPaper.vue?vue&type=script&lang=js&"
export * from "./teacherPaper.vue?vue&type=script&lang=js&"
import style0 from "./teacherPaper.vue?vue&type=style&index=0&id=f5fe46f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fe46f8",
  null
  
)

export default component.exports